export default __webpack_public_path__ + "static/media/mode-59.21312490.svg";